export default __webpack_public_path__ + "assets/republicofthecongo-flag.png";